import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { DEFAULT_PAGE_SAZE } from '../common/PrimeTable/CustomPrimeTable'
import { COLUMN_RESIZE_EXPAND } from '../constants/primeTableConstants'
import camelToSnake from '../utils/camelToSnake'

/**
 *
 * @param {*} defaultSort
 * @param {*} defaultPagination
 * @param {*} defaultTableFilter
 * @param {*} defaultFilter
 * @returns
 */
const useTablePaginationConfig = (defaultSort, defaultPagination, defaultTableFilter = {}, defaultFilter = {}) => {
  const DEFAULT_PAGINATION = { limit: DEFAULT_PAGE_SAZE, first: 0 }
  const hasDefaultPagination = defaultPagination && Object.keys(defaultPagination).length > 0
  const [options, setOptions] = useState({
    pagination: hasDefaultPagination ? defaultPagination : DEFAULT_PAGINATION,
    sort: defaultSort ? defaultSort : {},
    filter: { ...defaultFilter },
    tableFilter: { ...defaultTableFilter },
  })

  const expandMode = COLUMN_RESIZE_EXPAND

  const history = useHistory()

  const onPageChange = async (event) => {
    const pagination = { limit: event.rows, first: event.first }
    setOptions({ ...options, pagination })
  }

  const onFilterChange = async (event) => {
    let tableFilter = {}

    Object.keys(event.filters).forEach(function (key) {
      tableFilter[camelToSnake(key)] = event.filters[key].value
    })

    setOptions({ ...options, tableFilter: { ...options.tableFilter, ...tableFilter } })
  }

  const onSortChange = async (event) => {
    let sort = {}

    if (event.multiSortMeta) {
      event.multiSortMeta.forEach((row) => {
        sort[row.field] = row.order
      })
    }

    setOptions({ ...options, sort })
  }

  const changeOptionsData = (opt) => {
    setOptions((prev) => ({
      ...prev,
      ...opt,
      pagination: { ...DEFAULT_PAGINATION },
      tableFilter: {
        ...defaultTableFilter,
        ...opt.tableFilter,
      },
    }))
  }

  const sortMeta = (defaultSortMeta) => {
    if (options?.sort && Object.keys(options?.sort).length > 0) {
      const field = Object.keys(options?.sort)[0]
      const order = options?.sort[field]

      return [
        {
          field,
          order,
        },
      ]
    } else {
      if (defaultSortMeta) {
        return defaultSortMeta
      }

      return [{}]
    }
  }

  const encodeUrlOptions = () => {
    const { pagination, sort, tableFilter } = options

    const queryParams = encodeURIComponent(JSON.stringify({ query: { pagination, sort }, ...tableFilter }))

    history.push({
      pathname: history.location.pathname,
      search: `?${queryParams}`,
    })
  }

  const decodeUrlOptions = () => {
    let otherFiltersFromUrl = {}
    let queryOptionsFromUrl = {}
    if (history?.location?.search) {
      const decodedSearch = decodeURIComponent(history.location.search)
      const { query, ...filtersFromUrl } = JSON.parse(decodedSearch.substring(1))
      delete filtersFromUrl.query
      otherFiltersFromUrl = filtersFromUrl
      if (query) {
        const { pagination, sort } = query
        if (pagination && sort) {
          queryOptionsFromUrl = { pagination, sort }
        }
      }
    }

    setOptions((prev) => ({
      ...prev,
      ...queryOptionsFromUrl,
      tableFilter: {
        ...prev.tableFilter,
        ...otherFiltersFromUrl,
      },
    }))
  }

  return {
    options,
    setOptions,
    onPageChange,
    onFilterChange,
    onSortChange,
    changeOptionsData,
    expandMode,
    sortMeta,
    encodeUrlOptions,
    decodeUrlOptions,
  }
}

export default useTablePaginationConfig
